import { useState } from "react";

import Button from "../../../components/Button";
import Input from "../../../components/Input";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import referralSchema from "../schemas/referralSchema";

import { submitReferral } from "../api/submitRequest";

const SallieReferral = () => {
	const [error, setError] = useState("");
	const [success, setSuccess] = useState("");

	const {
		register,
		handleSubmit,
		reset,
		formState: { errors, isSubmitting },
	} = useForm({
		resolver: yupResolver(referralSchema),
	});

	const onSubmit = async (data) => {
		setError("");
		console.log("Done!");
		try {
			await submitReferral({
				userId: localStorage.getItem("userId"),
				recipientEmail: data.email,
			});
			setSuccess(`Referral email has been sent to ${data.email}`);
			reset();
		} catch (err) {
			console.error("Referring to Sallie Error", err);
			setError("Failed to send referral. Please try again.");
		}
	};

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<h3 className="md:text-base text-sm mb-2">
				Refer someone to Sallie and help them track their symptoms!
			</h3>
			<div className="flex flex-col gap-2 mb-2 md:flex-row md:items-start">
				<Input
					name="email"
					register={register}
					errors={errors}
					placeholder="Enter their email"
					className="w-full md:w-auto"
				/>
				<Button
					type="submit"
					isLoading={isSubmitting}
					className="w-full md:w-auto"
				>
					Refer to Sallie
				</Button>
			</div>
			{success && <p className="text-teal-600">{success}</p>}
			{error && <p className="text-red-600">{error}</p>}
		</form>
	);
};

export default SallieReferral;
